export default __webpack_public_path__ + "static/media/save.6976c38b.svg";